export interface Category {
  slug: string;
  name: string;
  short: string;
  desc: string;
  icon: string;
  accent: string;
}

export const categories: Category[] = [
  {
    slug: "zongmen",
    name: "宗门篇剧情",
    short: "宗门篇",
    desc: "从入门拜师到宗门内外恩怨，梳理宗门篇每一幕关键转折。",
    icon: "ri-community-line",
    accent: "text-primary-600",
  },
  {
    slug: "jingjie",
    name: "修炼境界",
    short: "修炼境界",
    desc: "炼气、筑基、金丹、元婴一路向上，把整套境界体系讲明白。",
    icon: "ri-fire-line",
    accent: "text-accent-600",
  },
  {
    slug: "zhuxian",
    name: "主线剧情",
    short: "主线走向",
    desc: "修仙主线如何推进，藏在日常里的伏笔又指向何方。",
    icon: "ri-road-map-line",
    accent: "text-secondary-600",
  },
  {
    slug: "juese",
    name: "角色志",
    short: "角色志",
    desc: "主角团与宗门众人的人物弧光、关系线与成长轨迹盘点。",
    icon: "ri-user-heart-line",
    accent: "text-primary-500",
  },
  {
    slug: "fubi",
    name: "伏笔盘点",
    short: "伏笔盘点",
    desc: "回看旧章细节，把作者悄悄埋下的线一条条挖出来。",
    icon: "ri-eye-2-line",
    accent: "text-accent-500",
  },
];